export const GET_ALERTS_REQUEST = 'GET_ALERTS_REQUEST';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_ERROR = 'GET_ALERTS_ERROR';

export const POST_ALERTS_REQUEST = 'POST_ALERTS_REQUEST';
export const POST_ALERTS_SUCCESS = 'POST_ALERTS_SUCCESS';
export const POST_ALERTS_ERROR = 'POST_ALERTS_ERROR';
